import React, { useEffect, useContext, useState, useRef } from 'react'
import { Droppable, Draggable } from 'react-beautiful-dnd'
import { v4 as uuidv4 } from 'uuid';

import { useNavigate } from 'react-router-dom';

import {
  Box,
  Popover,
} from '@material-ui/core';

import moreForAdmin from '../../../../images/moreForAdmin.svg'
import addForAdmin from '../../../../images/addForAdmin.svg'

import APIS from "../../../../utils/APIS"

import SuperAdminContext from "../../../../contexts/SuperAdminContext"
import PopupNotifContext from "../../../../contexts/PopupNotifContext"

import SideBarPartie from "./SideBarPartie"

const SideBarChapitre = ({ content, updateContent, id, iChap, actIndex, setIndex }) => {

  const { addChapitre, deleteChapitre, duplicateChapitre, addPartie } = useContext(SuperAdminContext)
  const { addPopupNotif } = useContext(PopupNotifContext)

  const popoverRef = useRef()

  const [isOpen, setIsOpen] = useState(true)
  const [menuOpen, setMenuOpen] = useState(false)

  const [title, setTitle] = useState("")

  useEffect(() => {
    setTitle(content?.chapitre[iChap]?.title)
  }, [])

  return (
    <Draggable
      key={'plan_chap_' + id}
      draggableId={'drag_chap_id_' + id}
      index={iChap}
    >
      {(provided, snapshot) => (
        <Box
          ref={provided.innerRef}
          sx={{
            borderBottom:"1px solid #2929292f",
          }}
          {...provided.draggableProps}
        >

          <Box
            {...provided.dragHandleProps}
            sx={{
              display:"flex",
              height:"40px",
              padding:"10px",
              alignItems:"center",
              justifyContent:"space-between",
              overflow:"hidden",
              "&:hover" : {
                ".viewOnHover" : {
                  opacity:"1 !important",
                }
              },
            }}
          >
            <Box sx={{
              display:"flex",
              gap:"10px",
              alignItems:"center",
              overflow:"hidden",
            }}>
              <Box
                onClick={(e) => {
                  setIsOpen(!isOpen)
                }}
                sx={{
                  cursor:"pointer",
                  transform:!isOpen&&"rotate(-90deg)",
                  userSelect:"none",
                }}
              >
                ▼
              </Box>
              <Box
                contentEditable="true"
                suppressContentEditableWarning={true}
                sx={{
                  fontWeight:"bold",
                  fontSize:"16px",
                  minWidth:"2px",
                  whiteSpace:"noWrap",
                  overflow:"hidden"
                }}
                onClick={(e) => {e.stopPropagation()}}
                onBlur={(e) => {
                  setTitle(e?.target?.textContent)
                }}
                onInput={(e) => {
                  let newFormation = JSON.parse(JSON.stringify(content))
                  newFormation.chapitre[iChap].title = e?.target?.textContent
                  updateContent(newFormation)
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  var text = '';
                  if (e.clipboardData || e.originalEvent.clipboardData) {
                    text = (e.originalEvent || e).clipboardData.getData('text/plain');
                  } else if (window.clipboardData) {
                    text = window.clipboardData.getData('Text');
                  }
                  if (document.queryCommandSupported('insertText')) {
                    document.execCommand('insertText', false, text);
                  } else {
                    document.execCommand('paste', false, text);
                  }
                }}
              >
                {title}
              </Box>
            </Box>
            <Box
              ref={popoverRef}
              sx={{flexShrink:0, opacity:1, cursor:"pointer", userSelect:"none", marginLeft:"5px"}}
              onClick={(e) => {
                e.stopPropagation()
                setMenuOpen(!menuOpen)
              }}
            >
              {menuOpen ? (
                <img src={addForAdmin} style={{width:"16px", transform:"rotate(45deg)"}} />
              ) : (
                <img src={moreForAdmin} className="viewOnHover" style={{width:"16px", opacity:0}} />
              )}
              <Popover
                open={menuOpen}
                anchorEl={popoverRef?.current}
                onClose={() => setMenuOpen(false)}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <Box sx={{
                  userSelect:"none",
                  padding:"0px 5px",
                  color:"black",
                }}>
                  <Box
                    sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
                    onClick={() => { deleteChapitre(iChap); }}
                  >
                    Supprimer
                  </Box>
                  <Box
                    sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
                    onClick={() => { duplicateChapitre(iChap); }}
                  >
                    Dupliquer
                  </Box>
                  <Box
                    sx={{padding:"10px", borderBottom:"1px solid #2929292f", cursor:"pointer"}}
                    onClick={() => {
                      let chapitre = JSON.stringify(content?.chapitre[iChap])
                      localStorage.setItem('copyPasteFormation', JSON.stringify({type:"formationChap", chapitre : chapitre}));
                      addPopupNotif({
                        uuid : uuidv4(),
                        title : "Chapitre copié",
                        type : "confirm",
                        removeAfter:3000,
                      })
                    }}
                  >
                    Copier
                  </Box>
                  <Box
                    sx={{padding:"10px", cursor:"pointer"}}
                    onClick={() => {
                      let infos = JSON.parse(localStorage.getItem('copyPasteFormation'))
                      if (infos && infos?.chapitre && infos?.type === "formationChap") {
                        let newChapitre = JSON.parse(infos?.chapitre)

                        addChapitre(iChap + 1, iChap + 1, newChapitre)
                      } else {
                        addPopupNotif({
                          uuid : uuidv4(),
                          title : "Aucune données",
                          type : "error",
                          removeAfter:3000,
                        })
                      }
                    }}
                  >
                    Coller (après)
                  </Box>
                </Box>
              </Popover>
            </Box>

          </Box>

          {isOpen &&
            <Box>
              <Droppable
                key={'key_plan_chap_droppable_' + id}
                droppableId={id + '_droppableParts'}
                type={`droppablePartie`}
              >
                {(provided, snapshot) => (
                  <div ref={provided.innerRef}>
                    {content?.chapitre[iChap]?.partie?.map((partie, iPart) => {
                      return (
                        <SideBarPartie
                          content={content}
                          updateContent={updateContent}
                          iPart={iPart}
                          iChap={iChap}
                          partId={partie?.id}
                          chapId={id}
                          key={'key_plan_chap_'+id+'_part_' + partie?.id}
                          actIndex={actIndex}
                          setIndex={setIndex}
                        />
                      )
                    })}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
              <Box
                sx={{
                  paddingLeft:"37px",
                }}
              >
                <Box
                  sx={{
                    display:"flex",
                    gap:"8px",
                    height:"30px",
                    alignItems:"center",
                    fontSize:"14px",
                    userSelect:"none",
                    cursor:"pointer",
                    position:"relative",
                    "::after" : {
                      content : '""',
                      position:"absolute",
                      width:"212px",
                      height:"1px",
                      background:"#2929292f",
                      top:0,
                      left:"-7px",
                    },
                  }}
                  onClick={() => {
                    addPartie({ iChap: iChap, iPart: content?.chapitre[iChap]?.partie?.length })
                  }}
                >
                  <img src={addForAdmin} style={{width:"16px"}} />
                  <Box>Ajoutez une partie</Box>
                </Box>
              </Box>
            </Box>
          }


        </Box>
      )}
    </Draggable>
  )
};

export default SideBarChapitre;
